if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"frontend","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(1439|6891|8876|8940)|2(0250|4330|5874|7207|8485)|4(0407|2842|6022|8196)|5(0138|044|1791|8202|8853)|6(0299|2448|5314|5911)|7(324|47|8795|9282)|8(2707|4195|7148|9803)|32620|36912|91282|93997)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}